import React from 'react';
import { useApp } from '../context/AppContext';

/**
 * Botón de acción RBAC: visible solo con permiso; sin badge contradictorio.
 * @param {{ module: string, action: 'create'|'edit'|'delete'|'approve'|'export'|'admin', children: React.ReactNode, className?: string, onClick?: () => void, disabled?: boolean }} props
 */
export function AuthorizedAction({ module, action, children, className = 'btn btn--primary', onClick, disabled = false }) {
  const { canCreate, canEdit, canDelete, canApprove, canExport, canAdmin } = useApp();
  const check = {
    create: canCreate,
    edit: canEdit,
    delete: canDelete,
    approve: canApprove,
    export: canExport,
    admin: canAdmin,
  }[action];
  const allowed = check ? check(module) : false;
  if (!allowed) return null;
  return (
    <button type="button" className={className} onClick={onClick} disabled={disabled}>
      {children}
    </button>
  );
}

/** Texto de ayuda cuando no hay permiso (opcional, fuera del toolbar principal). */
export function PermissionHint({ module, action }) {
  const { t, canCreate, canEdit, permSummary } = useApp();
  const check = action === 'create' ? canCreate(module) : canEdit(module);
  if (check || !permSummary) return null;
  return (
    <p className="perm-hint text-sm panel__muted" role="status">
      {t('permissions.hintMissing', { module, action })}
    </p>
  );
}
